export const getMenuData = [
  {
    title: 'Dashboard',
    lang: 'dashboard',
    key: 'dashboard',
    icon: 'fe fe-home',
    url: '/dashboard',
    roles: ['fund_raiser'],
  },
  {
    title: 'Sales',
    lang: 'sales',
    key: 'sales',
    icon: 'fe fe-database',
    roles: ['fund_raiser'],
    children: [
      {
        title: 'Order List',
        lang: 'orderList',
        key: 'order-list',
        url: '/sales',
        roles: ['fund_raiser'],
      },
      {
        title: 'Commission List',
        lang: 'commissionList',
        key: 'list-commission',
        url: '/account/list-commission',
        roles: ['fund_raiser'],
      },
    ],
  },
  // {
  //   title: 'Purchase Order',
  //   key: 'purchase',
  //   lang: 'purchase',
  //   icon: 'fe fe-shopping-cart',
  //   roles: ['distributor'],
  //   children: [
  //     {
  //       title: 'Catalogue',
  //       key: 'catalogue',
  //       lang: 'purchaseCatalogue',
  //       url: '/purchase/catalogue',
  //       roles: ['distributor'],
  //     },
  //     {
  //       title: 'Purchase List',
  //       key: 'purchaseList',
  //       lang: 'purchaseList',
  //       url: '/purchase',
  //       roles: ['distributor'],
  //     },
  //     {
  //       title: 'Create Purchase',
  //       key: 'createPurchase',
  //       lang: 'createPurchase',
  //       url: '/purchase/add',
  //       roles: ['distributor'],
  //     },
  //   ],
  // },
  {
    title: 'Store',
    lang: 'store',
    key: 'store',
    icon: 'fe fe-shopping-bag',
    roles: ['fund_raiser'],
    children: [
      {
        title: 'Available Products',
        lang: 'availableProducts',
        key: 'product-list',
        url: '/store/available-products',
        roles: ['fund_raiser'],
      },
      {
        title: 'My Products',
        lang: 'myProducts',
        key: 'product-in-store',
        url: '/store/my-products',
        roles: ['fund_raiser'],
      },
      {
        title: 'Setting',
        lang: 'setting',
        key: 'setting',
        url: '/store/store-settings',
        roles: ['fund_raiser'],
      },
      {
        title: 'View Store',
        lang: 'viewStore',
        key: 'my-store',
        url: 'store_url',
        roles: ['fund_raiser'],
      },
    ],
  },
  {
    title: 'Account',
    lang: 'account',
    key: 'account',
    icon: 'fe fe-user-plus',
    roles: ['fund_raiser'],
    children: [
      {
        title: 'Edit Profile',
        lang: 'editProfile',
        key: 'edit-profile',
        url: '/account/edit-profile',
        roles: ['fund_raiser'],
      },
      {
        title: 'E-wallet History',
        lang: 'ewalletHistory',
        key: 'ewallet-history',
        url: '/account/ewallet',
        roles: ['fund_raiser'],
      },
      {
        title: 'Withdraw Request',
        lang: 'withdrawRequest',
        key: 'withdraw-request',
        url: '/account/withdraw-request',
        roles: ['fund_raiser'],
      },
    ],
  },
]
